import { createSlice } from "@reduxjs/toolkit";
import { IMetadata } from "../model/slices/IMetadata";
import { DEFAULT_ARTWORK } from "../model/API";

const metadataSlice = createSlice({
  name: "artwork",
  initialState: {
    artist: "X MUSIC",
    title: "Érezd magad jól!",
    artwork: DEFAULT_ARTWORK,
  },
  reducers: {
    setNewMetadata(state, action: { payload: IMetadata }) {
      state.artist = action.payload.artist;
      state.title = action.payload.title;
      state.artwork = action.payload.artwork;
    },
    resetMetadata(state) {
      state.artist = "X MUSIC";
      state.title = "Érezd magad jól!";
      state.artwork = DEFAULT_ARTWORK;
    },
  },
});

export const { setNewMetadata, resetMetadata } = metadataSlice.actions;
export default metadataSlice.reducer;
